const Form099EN = {
    stepName: {
        importantNotes: "Important Notes",
        basicInfo: "Basic Information",
        confirmation: "Confirmation",
    },
    importantNotes: {
        tableTitle:
            "Hong Kong Budding Scientists Award Student Nomination Form",
        follow: "Please pay attention to the following:",
        num: {
            n1: "(1) ",
            n2: "(2) ",
            n3: "(3) ",
            n4: "(4) ",
            n5: "(5) ",
            n6: "(6) ",
        },
        serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],

        n1: "Schools should inform students and their parents/guardians that in the course of the competition, the EDB and persons/parties authorised by the EDB may take photographs and videos in which the students appear. The photographs and videos may be used for publicity purposes by the EDB in print or digitally. Schools or parents/guardians who have any concern about the arrangement may write to <a href='mailto:cdoge1@edb.gov.hk'>cdoge1@edb.gov.hk</a>.",

        n2: "Eligibility:",
        n21: "Primary Section: each primary school ought to nominate three to five P.4 to P.6 students (at most two P.6 students);",
        n22: "Secondary Section: each secondary school ought to nominate three to five S.1 to S.4 students (at most two S.4 students);",
        n23: "Team members CANNOT be replaced once the Student Nomination Form is submitted.",

        n3: "Please check the submitted information carefully. Related information, including the entries of this competition will be used for the printing of corresponding certificates and booklet of the Hong Kong Budding Scientists Award or other educational uses.",
        n4: "The entries of this competition must be original and must not infringe any copyrighted materials. Schools are not allowed to submit students’ products which have been used in other competitions for the Hong Kong Budding Scientists Award.",
        n5: "All information related to this competition including students' results and arrangements of the Heat, Final cum Prize Presentation Ceremony will be uploaded to the competition webpage <a href='http://www.edb.gov.hk/en/BSA' target='_blank' rel='noreferrer'>http://www.edb.gov.hk/en/BSA</a>.",
        n6: "Participating schools are required to check the competition webpage regularly for the updates without further notification.",
    },
    sectionA: {
        title: "(A) Personal Particulars of Coach Teacher(s)",
        teacherEngName: "Name of Teacher(s) (in English)",
        teacherChName: "Name of Teacher(s) (in Chinese)",
        mobile: "Mobile",
        email: "Email",
        schoolEngName: "Name of School (in English)",
        schoolChName: "Name of School (in Chinese)",
        schoolTel: "School Tel. No.",
        schoolFax: "School Fax. No.",
    },
    sectionB: {
        title: "(B) Student Contestants",
        engName: "Name in English",
        chName: "Name in Chinese",
        form: "Form",
        formTips:
            "Eligibility: \nPrimary Section: each primary school ought to nominate three to five P.4 to P.6 students (at most two P.6 students); \nSecondary Section: each secondary school ought to nominate three to five S.1 to S.4 students (at most two S.4 students); \nTeam members CANNOT be replaced once the Student Nomination Form is submitted.",
        formOption: {
            p4: "P.4",
            p5: "P.5",
            p6: "P.6",
            s1: "S.1",
            s2: "S.2",
            s3: "S.3",
            s4: "S.4",
        },
        formPriOption: {
            p4: "P.4",
            p5: "P.5",
            p6: "P.6",
        },
        formSecOption: {
            s1: "S.1",
            s2: "S.2",
            s3: "S.3",
            s4: "S.4",
        },
    },
    label: {
        selectedLanguage:
            "Please put a ✓ against the selected language for the competition",
        signatureHead: "Signature School Head",
        headName: "Name of School Head",
        date: "Date",
        schoolChop: "School Chop",
        selectLangOption: {
            chinese: "Chinese",
            english: "English",
        },
    },
    errorMsg: {
        faxMax12: "Fax number must be at most 12 digits",
        selectOneSection:
            "Please select the same grade to participate in the competition",
        selectListP:
            "Each primary school ought to nominate three to five P.4 to P.6 students",
        selectListS:
            "Each secondary school ought to nominate three to five S.1 to S.4 students",
        selectMoreP: "At most two P.6 students",
        selectMoreS: "At most two S.4 students",
        selectLeastP:
            "Each primary school ought to nominate three to five students",
        selectLeastS:
            "Each secondary school ought to nominate three to five students",
        selectLeast: "Each school ought to nominate three to five students",
    },
    formExpired:
        "The student nomination for the Hong Kong Budding Scientists Award is closed.",
};
export default Form099EN;
